var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-select',{attrs:{"value":_vm.value},on:{"change":_vm.changeHandler}},_vm._l((_vm.options),function(option,index){return _c('a-select-option',{key:index,attrs:{"value":option.value}},[_vm._v(_vm._s(option.name))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }